<div *ngIf="isHeaderLoading" class="header-loader">
  <mat-spinner diameter="40"></mat-spinner>
</div>
<mat-toolbar class="topbar" *ngIf="!isHeaderLoading">
  <button mat-icon-button (click)="toggleMobileNav.emit()" *ngIf="!showToggle">
    <mat-icon>menu</mat-icon>
  </button>

<div class="search-container" #searchContainer>
    <input
  #searchInput
  type="search"
  [name]="'global-search-' + randomId"
  id="global-search-box"
  placeholder="Search"
  autocomplete="off"
  data-lpignore="true"
  data-1p-ignore
  readonly
  (focus)="searchInput.removeAttribute('readonly'); onSearchFocus()"
  [(ngModel)]="searchQuery"
  (input)="onSearchInput()"
  class="search-input" />
  <i class="material-icons search-icon" *ngIf="!searchQuery">search</i>
<button type="button"
        class="clear-btn"
        *ngIf="searchQuery"
        (click)="clearSearchText(searchInput)"
        style="position:absolute; right:10px; left:auto; top:50%; transform:translateY(-50%);
               width:28px; height:28px; border:none; background:transparent; border-radius:50%;
               display:flex; align-items:center; justify-content:center; cursor:pointer;
               color:#6b7280; padding:0; z-index:5;">
  <i class="material-icons" *ngIf="!searchQuery"
     style="color:#6b7280; font-size:22px; margin-left:10px;">search</i>
     <button type="button" *ngIf="searchQuery" (click)="clearSearchText(searchInput)"
          style="border:none; background:transparent; cursor:pointer; padding:0; margin-left:70px; display:flex; align-items:center; color:#6b7280;">
    <i class="material-icons" style="font-size:20px; margin-left: 680px;">close</i>
  </button>
  </button>
  <div *ngIf="showFilters && UserType === 'Admin'" class="filter-tabs" >
 <button
 
  *ngFor="let category of categories"
  (click)="onCategoryClick(category)"
  [class.active]="selectedCategory === category">

  {{ category }}

  <span *ngIf="getCount(category) > 0">
    ({{ getCount(category) }})
  </span>

</button>
  </div>
  <ul *ngIf="filteredPages.length && UserType === 'Admin'" class="search-results">
    <li *ngFor="let group of groupedResults">
      <div class="group-title">{{ group.category }}</div>
      <ul>
        <li 
          *ngFor="let page of group.items"
          (click)="onResultClick(page)"
          [class.active]="selectedPage?.name === page.name"
          [class.matched]="isMatch(page)">
          {{ page.name }}
        </li>
      </ul>
    </li>
  </ul>
</div>
  <span class="flex-1-auto"></span>
<a *ngIf="UserType === 'Admin'"  href="../../../../assets/Help Docs 1/Help Docs/Dashboard.html"
   target="_blank"
   rel="noopener noreferrer"
   class="help-link">
  Help
</a>
<button class="icon-btns">QA</button>
<button mat-icon-button aria-label="Notifications"  class="icon-btn" (click)="toggleDropdown()">
  <mat-icon aria-hidden="false" style="color: black;" class="icon-outline" >notifications</mat-icon>
  <span class="badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
</button>
<mat-menu #filterMenu="matMenu" class="filter-menu">
 <div class="filter-container">
     <mat-checkbox
    [(ngModel)]="categorySelection['All']"
    (change)="onCategoryChange('All')"
    (click)="$event.stopPropagation()">
    All
  </mat-checkbox>
  <mat-checkbox
    *ngFor="let c of categories1"
    [(ngModel)]="categorySelection[c]"
    (ngModelChange)="onCategoryChange(c)"
    (click)="$event.stopPropagation()">
    {{ c }}
  </mat-checkbox>
  </div>
  <button 
  type="button"
  mat-menu-item 
  (click)="closeMenu(); $event.stopPropagation();">
  <mat-icon>close</mat-icon>
</button>
</mat-menu>
<div class="notification-dropdown" *ngIf="dropdownOpen && UserType === 'Customer'">
<div class="dropdown-header">
  <span>Notifications</span>
  <div class="button-group">
    <button class="filter-btn"
            (click)="toggleSortNotifications()"
            matTooltip="Sort By Created Date">
      <mat-icon style="color: black;">swap_vert</mat-icon>
    </button>
    <button class="filter-btn"
            [matMenuTriggerFor]="filterMenu"
            #menuTrigger="matMenuTrigger"
            (click)="$event.stopPropagation()"
            [matMenuTriggerRestoreFocus]="false"
            matTooltip="Filter By Data">
      <mat-icon style="color: black;">filter_alt</mat-icon>
    </button>
    <button [disabled]="unreadCount === 0" (click)="markAllAsSeen()">Mark all as read</button>
  </div>
</div>
 <div class="notification-section">
    <ul>
      <li *ngFor="let item of filteredNotifications" [class.unread]="!item.seen">
        <div class="avatar">{{ item.initials }}</div>
        <div class="content" (click)="markAsSeen(item)">
            <strong>{{ item.name }}</strong><br>
      <div [innerHTML]="item.message" class="message-text"></div>
            <a (click)="handleClick(item)" class="link-button">click here</a>
    <small>
  {{ item.timeAgo }} | {{ item.date | date:'dd MMM yyyy, hh:mm a' }}
</small>
        </div>
      </li>
    </ul>
  </div>
    <div *ngIf="filteredNotifications.length === 0" class="no-notifications">
    No notifications
  </div>
</div>


<button class="profile-pill" [matMenuTriggerFor]="profilemenu">
  <img *ngIf="avatar" [src]="avatar" class="profile-pill-avatar" alt="" />

</button>

<mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
  <div class="profile-header" [matTooltip]="FirstName || '-'" matTooltipPosition="below">
    {{ Username || '-' }}
  </div>

  <button mat-menu-item [routerLink]="['/Customer/Profile']" *ngIf="UserType === 'Customer'">
    <mat-icon class="d-flex align-items-center icon-outline">person</mat-icon>
    My Profile
  </button>

  <button mat-menu-item [routerLink]="['/Admin-ops/MyProfile']" *ngIf="UserType === 'Admin'">
    <mat-icon class="d-flex align-items-center icon-outline">person</mat-icon>
    My Profile
  </button>


  <button mat-menu-item (click)="ChangePassword()">
  <mat-icon>lock</mat-icon>
  <span>Change Password</span>
</button>
  <button mat-menu-item (click)="logout()" >
    <mat-icon class="d-flex align-items-center">logout</mat-icon>
    Logout
  </button>
</mat-menu>
</mat-toolbar>
<style>
/* ============ Base / structural ============ */
.header-loader {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.topbar-dd .mat-mdc-menu-item:hover {
  background-color: #C8DAEA !important;
  color: black !important;
}
.topbar {
  position: relative !important;
 
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  padding: 0 12px;
}
.flex-1-auto {
  flex: 1 1 auto;
}
.topbar-dd.cardWithShadow {
  background-color: #ECEFF3 !important;
  transition: background-color 0.3s ease;
}



.search-container {
  position: relative;
  display: flex;
  align-items: center;
  flex: 0 1 auto;         
  min-width: 0;           
  width: 100%;
  max-width: 800px;
  box-sizing: border-box;
}

.search-input {
  width: 100%;
  height: 42px;
  padding: 0 10px 0 12px;
  padding-right: 40px !important;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #000;
  outline: none;
  box-sizing: border-box;
}
.search-input:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 4px rgba(13, 110, 253, 0.2);
}

.search-input::-webkit-search-cancel-button,
.search-input::-webkit-search-decoration {
  -webkit-appearance: none;
  display: none;
}
.clear-btn {
  position: absolute;
  right: 8px;
  top: 21px;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #6b7280;
  padding: 0;
}
.clear-btn:hover {
  background: #f1f5f9;
  color: #111827;
}
.clear-btn .material-icons {
  font-size: 20px;
}
.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 22px;
  color: #6b7280;
  pointer-events: none;
}

.filter-tabs {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0;
  background: #f9fafb;
  border-bottom: 1px solid #dcdcdc;
  padding: 0;
  position: absolute;
  top: 46px;
  left: 0;
  width: 100%;
  z-index: 20;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  height: 42px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.06);
}
.filter-tabs button {
  flex: 1 1 auto;
  border: none;
  background: #f9fafb;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  padding: 10px 16px;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  transition: all 0.25s ease;
  position: relative;
  min-width: 100px;
  white-space: nowrap;
}
.filter-tabs button:hover {
  background-color: #f1f5f9;
  color: #0d6efd;
}
.filter-tabs button.active {
  background: #fff;
  color: #000;
  font-weight: 600;
  border-bottom: 3px solid #0953c2;
  z-index: 2;
}
.filter-tabs button span {
  color: #0d6efd;
  font-weight: 500;
  margin-left: 4px;
  font-size: 13px;
}

.search-results {
  position: absolute;
  top: 48px;
  left: 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  max-height: 350px;
  overflow-y: auto;
  z-index: 10;
  box-sizing: border-box;
  padding-bottom: 10px;
}

.group-title {
  font-weight: 600;
  color: #444;
  font-size: 14px;
  padding: 12px 20px 6px;
  border-bottom: 1px solid #f1f1f1;
  margin-bottom: 6px;
}

.search-results ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.search-results li {
  font-size: 14px;
  color: #222;
  cursor: pointer;
  transition: background 0.2s ease;
  padding: 8px 20px;
}
.search-results li.active {
  background-color: #e9f2ff;
  color: #0d6efd;
}
.search-results li.matched {
  background-color: #e6f0ff !important;
  color: #0953c2 !important;
  font-weight: 500;
  border-radius: 4px;
}

.no-results-box {
  width: 100%;
  background: #fff;
  padding: 18px;
  text-align: center;
  font-size: 15px;
  color: #444;
  border-left: 1px solid #e2e2e2;
  border-right: 1px solid #e2e2e2;
  border-bottom: 1px solid #e2e2e2;
  border-radius: 0 0 8px 8px;
}

/* ============ Right-side action buttons ============ */
.help-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  flex-shrink: 0;
}
.help-link:hover {
  color: #1e40af;
  transform: translateY(-1px);
}
.help-link:active {
  transform: translateY(0);
  box-shadow: none;
}

.icon-btns {
  background-color: #FFC8AF;
  height: 40px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #dcdcdc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  flex-shrink: 0;
}

.icon-btn {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;


  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  background: #fff;
  border-radius: 50%;
  position: relative;
}

.icon-btn .mat-icon,
.icon-btn mat-icon {
  margin: 0 !important;
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge {
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: red;
  color: white;
  font-size: 11px;
  border-radius: 50%;
  padding: 3px 6px;
  font-weight: 600;
}

.mat-badge-content {
  background-color: #e63946 !important;
  color: white !important;
  font-weight: bold;
  font-size: 12px;
  box-shadow: 0 0 4px rgba(0,0,0,0.2);
}

/* ============ Profile name pill (last item, matches provided screenshot) ============ */
.profile-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 10px 0 6px;
  background-color: #ECEFF3;   /* navy, matches screenshot */
  color: #ffffff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  flex-shrink: 1;
min-width: 0px;
max-width: 400px;
  box-sizing: border-box;
  transition: background-color 0.2s ease;
}
.profile-pill:hover {
  background-color: #C8DAEA;
}
.profile-pill-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
  background: #ffffff;
}
.profile-pill-name {
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.profile-pill-arrow {
  color: #0060AE;
  flex-shrink: 0;
  font-size: 20px;
  height: 20px;
  width: 20px;
  line-height: 20px;
}

/* ============ Filter menu (checkbox list) ============ */
.filter-menu {
  background-color: #f5f6f7 !important;
  padding: 0 !important;
}
.filter-container {
  padding: 0.2rem 0.1rem 0.1rem 0.2rem;
  font-family: "Inter", sans-serif;
  width: 250px;
  max-width: 90vw;
  background-color: #f5f6f7;
  max-height: 350px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-sizing: border-box;
}
.filter-container mat-checkbox {
  white-space: nowrap;
}
.filter-btn {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  transition: background-color 0.2s, transform 0.1s;
}
.filter-btn:hover {
  background-color: #f0f0f0;
  transform: scale(1.05);
}
.sort-icon {
  color: black;
  font-size: 24px;
}

/* ============ Category tabs (unused elsewhere but kept responsive) ============ */
.category-tabs {
  display: flex;
  gap: 5px;
  padding: 8px 12px;
  border-bottom: 1px solid #ddd;
  background-color: #fafafa;
  overflow-x: auto;
}
.category-tabs button {
  background: none;
  border: 1px solid transparent;
  padding: 2px 5px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 10px;
  font-weight: 500;
  color: #555;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.category-tabs button:hover {
  background-color: #f1f1f1;
}
.category-tabs button.active {
  background-color: #0078d4;
  color: white;
  border-color: #0078d4;
}

.link-button {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.2s ease;
}
.link-button:hover {
  color: #0056b3;
}
.link-button:active {
  color: #003d80;
}

/* ============ Notifications dropdown ============ */
.notification-container {
  position: relative;
  display: inline-block;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.notification-dropdown {
  position: absolute;
  right: 0;
  top: 55px;
  width: 420px;
  max-width: calc(100vw - 24px);   /* never overflow the viewport */
  max-height: 480px;
  overflow-y: auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  z-index: 9999;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  box-sizing: border-box;
}
.dropdown-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  border-bottom: 1px solid #eee;
  font-weight: 600;
  flex-wrap: wrap;
  gap: 6px;
}
.button-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.dropdown-header button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
}
.dropdown-header button:disabled {
  color: #ccc;
  cursor: not-allowed;
}
.section-title {
  font-size: 13px;
  font-weight: 600;
  padding: 0 16px;
  margin-top: 10px;
  color: #666;
}
.notification-section ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.notification-section li {
  display: flex;
  align-items: flex-start;
  padding: 10px 16px;
  border-bottom: 1px solid #f5f5f5;
  transition: background 0.2s ease;
  cursor: pointer;
}
.notification-section li.unread {
  background-color: #f6f9ff;
}
.notification-section li:hover {
  background-color: #f9fbff;
}
.avatar {
  background: #e8eefe;
  color: #333;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-right: 10px;
  flex-shrink: 0;
}
.content {
  flex: 1;
  font-size: 13px;
  line-height: 1.4;
  overflow-wrap: break-word;
  min-width: 0;
}
.main-text {
  margin: 0;
}
.clickable-name {
  color: #000;
  cursor: pointer;
}
.clickable-name:hover {
  text-decoration: underline;
}
.expanded-content {
  background: #fafafa;
  border-radius: 8px;
  padding: 8px 10px;
  margin-top: 6px;
  font-size: 12px;
  color: #444;
}
.no-notifications {
  text-align: center;
  padding: 20px;
  color: #777;
  font-size: 14px;
}
.message-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-height: 6em;
  line-height: 1.5em;
  white-space: normal;
  color: #333;
}

/* ============ Profile / menu items ============ */
.action-menu {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.5rem 1rem;
  border: none;
  background: none;
  cursor: pointer;
  color: #333;
  font-size: 0.875rem;
  font-weight: 600;
  text-align: center;
}
.action-menu:hover {
  background-color: blue;
  color: white;
}
.profile {
  display: flex;
  align-items: center;
}
.profile-image {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  margin-right: 0.625rem;
}
.profile-info {
  font-family: Arial, sans-serif;
  margin-top: 1rem;
}
.greeting {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}
.date {
  font-size: 0.875rem;
  color: white;
  margin: 0;
}

/* ============ Responsive breakpoints ============ */

/* Large desktop: plenty of room, nothing special needed beyond base rules */

/* Tablet / laptop */
@media screen and (max-width: 1450px) and (min-width: 1150px) {
  .search-container {
    max-width: 480px;
  }
}

/* Small laptop / large tablet */
@media (max-width: 1024px) {
  .topbar {
    padding: 0 8px;
  }
  .search-container {
    max-width: 360px;
    margin: 0 10px;
  }
  .help-link {
    padding: 8px 14px;
  }
  .profile-pill {
    max-width: 160px;
  }
}

/* Tablet portrait */
@media (max-width: 900px) {
  .search-container {
    max-width: 260px;
  }
  .help-link span,
  .help-link {
    font-size: 13px;
    padding: 6px 10px;
  }
  .icon-btns {
    padding: 0 8px;
    font-size: 13px;
  }
  .notification-dropdown {
    width: 360px;
  }
  .profile-pill {
    max-width: 130px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .topbar {
    gap: 4px;
    padding: 0 6px;
  }
  .search-container {
    max-width: none;
    flex: 0 1 auto;
    width: auto;
    margin: 0 8px;
  }
  .search-icon {
    display: none;
  }
  .filter-tabs {
    flex-wrap: wrap;
    height: auto;
    border-radius: 0;
    position: absolute;
    top: 44px;
  }
  .filter-tabs button {
    flex: 1 1 50%;
    text-align: center;
    padding: 8px;
    min-width: 0;
  }
  /* Keep everything visible on mobile — just shrink so it all fits in one row. */
  .help-link {
    padding: 6px 10px;
    font-size: 12px;
  }
  .icon-btns {
    padding: 0 8px;
    font-size: 12px;
  }
  .icon-btn {
    width: 36px;
    height: 36px;
  }
  .profile-pill {
    max-width: 110px;
    padding: 0 6px 0 4px;
  }
  .profile-pill-name {
    font-size: 12px;
  }
}
.profile-header {
  display: block;
  width: 100%;
  max-width: 220px;      
  padding: 10px 16px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;  
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 4px;
  box-sizing: border-box;
}
/* Small mobile */
@media (max-width: 600px) {
  .topbar {
    gap: 2px;
  }
  .search-container {
    margin: 0 4px;
  }
  .search-input {
    font-size: 1rem;
    height: 2.25rem;
    border-radius: 0.625rem;
    padding: 0 8px;
  }
  .search-results {
    top: 44px;
  }
  .help-link {
    padding: 4px 6px;
    font-size: 11px;
  }
  .icon-btns {
    padding: 0 6px;
    font-size: 11px;
    height: 34px;
  }
  .icon-btn {
    width: 32px;
    height: 32px;
  }
  .notification-dropdown {
    position: fixed;
    top: 60px;
    right: 8px;
    left: 8px;
    width: auto;
    max-width: none;
  }
  .visually-hidden-input {
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
  pointer-events: none;
}
  /* On very narrow phones, drop the text and keep just avatar + arrow so
     the row still fits. Remove this rule if you'd rather always show the name. */
  .profile-pill {
    max-width: 44px;
    padding: 0 4px;
    gap: 2px;
  }
  .profile-pill-name {
    display: none;
  }
}

/* Very small mobile */
@media (max-width: 380px) {
  .search-container {
    min-width: 60px;
  }
  .help-link {
    padding: 4px 5px;
    font-size: 10px;
  }
  .icon-btns {
    padding: 0 5px;
    font-size: 10px;
  }
  .search-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 42px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  box-sizing: border-box;
}
.search-box:focus-within {
  border-color: #0d6efd;
  box-shadow: 0 0 4px rgba(13, 110, 253, 0.2);
}
}
</style>